module.exports = __webpack_public_path__ + "static/img/saoma_c.246dd4f1.png";